export const shadow = [
    'none',
    'small-icon',
    'icon-white',
    'dropdown',
    'card',
    'card-hover',
    'tab',
    'sticky-side-menu',
    'chart-line',
    'illustration-element',
    'illustration-blured-gray',
    'mesh-line-vertical',
    'mesh-line-horizontal',
    'inset',
    'inner',
    'inner-90',
    'inner-45',
    'pie-chart-placeholder',
];
export const isShadow = (x) => shadow.includes(x);
